import React from 'react'
import { Box, Text } from '@deseretbook/react-ui'
import './AttributesCard.css'
import { formatDateString, formatDurationLong } from '../../../utils/base'

const AttributesCard = ({ media, isEbook, isAudiobook }) => {
  // Extract necessary values
  const { categories = [], languages = [], publisher = {} } = media
  const length = isAudiobook ? formatDurationLong(media.audiobook.length) : media.ebook.length
  const releaseDate = isEbook ? media.ebook.releaseDate : media.audiobook.releaseDate

  // Build a dynamic list of attributes, only including those with a value.
  const attributes = []

  if (categories && categories.length) {
    attributes.push({
      title: 'Genre',
      value: categories[0].name,
    })
  }
  if (length) {
    attributes.push({
      title: 'Length',
      value: length,
    })
  }
  if (releaseDate) {
    attributes.push({
      title: 'Released',
      value: formatDateString(releaseDate),
    })
  }
  if (publisher && publisher.name) {
    attributes.push({
      title: 'Publisher',
      value: publisher.name,
    })
  }
  if (languages && languages.length) {
    // Join multiple languages with commas, if needed.
    const languageNames = languages.map((language) => language.name).join(', ')
    attributes.push({
      title: 'Language',
      value: languageNames,
    })
  }

  // Split attributes into two columns:
  const leftColumnAttributes = attributes.slice(0, 3)
  const rightColumnAttributes = attributes.slice(3)

  // Helper function to render each attribute item
  const renderAttribute = ({ title, value }) => (
    <Box key={title} className="attributes-item">
      <Text className="attributes-item-title">{title}</Text>
      <Text className="attributes-item-value">{value}</Text>
    </Box>
  )

  return (
    <Box alignItems="start" justifyContent="start" id="attributes-container">
      <Box isColumn alignItems="start" className="attributes-column attributes-column-left">
        {leftColumnAttributes.map(renderAttribute)}
      </Box>
      {rightColumnAttributes.length > 0 && (
        <Box
          isColumn
          alignItems="start"
          justifyContent="center"
          className="attributes-column attributes-column-right"
        >
          {rightColumnAttributes.map(renderAttribute)}
        </Box>
      )}
    </Box>
  )
}

export default AttributesCard
